import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useSettings(): RootState["settings"] {

    const settings = useSelector<RootState, RootState["settings"]>(
        ({ settings }) => settings ?? {}
    )

    return settings
}
